export default __webpack_public_path__ + "static/media/FDL_Red.d2000547.png";